import React from 'react';
import { useNavigate } from 'react-router-dom';
import './About.css';

const About = () => {
    const navigate = useNavigate();

    return (
        <section id="about" className="about section-padding">
            <div className="container about-grid">
                <div className="about-left" style={{marginBottom:"68px"}}>
                    <div className="main-image-wrapper">
                        <img src="https://sakthivel.ascentbw.com/Files/Home/1About.png" alt="CNC Machine" className="about-main-img" />
                     
                    </div>
                    <div className="about-text-content">
                        <h3>Our Manufacturing Facility</h3>
                        <p>Equipped with advanced CNC and VMC machines, our facility in Ambattur Industrial Area, Chennai, is built to deliver precision, consistency, and timely project completion.</p>
                        <button className="btn-primary" onClick={() => navigate('/about')}>Know More</button>
                    </div>
                </div>

                <div className="about-right">
                    <div className="section-header">
                        <h2 className="section-title">Reliable Precision</h2>
                        <h2 className="section-subtitle highlight">Machining Services</h2>
                        <p className="section-desc">Sakthivel Engineering specializes in precision CNC, VMC, drilling, milling, and cutting operations. We manufacture high-quality industrial components tailored to meet the requirements of manufacturing and engineering industries.</p>
                    </div>

                    <div className="stats-grid">
                        <div className="stat-item">
                            <span className="stat-number">2+</span>
                            <span className="stat-label">Advanced precision <br /> machining capability</span>
                        </div>
                        <div className="stat-item">
                            <span className="stat-number">12+</span>
                            <span className="stat-label">High production <br /> support capacity</span>
                        </div>
                    </div>

                    <div className="secondary-image-wrapper">
                        <img src="https://sakthivel.ascentbw.com/Files/Home/2About.png" alt="Precision Tooling" className="about-sec-img" />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default About;
